export default __webpack_public_path__ + "static/media/Ali Profile.7f32137e.jpeg";